export const ROUTE_PATH = '/bitrix';
